const solutions = [
  {
    title: 'Internationale Zahlungsanbieter',
    description: 'Vollständige Integration von Shopify Payments, PayPal, Klarna, Stripe, Mollie und weiteren Anbietern. Automatisierte Verbuchung aller Transaktionen auf Einzeltransaktionsebene, rechts- und prüfungssicher.',
    image: 'https://public.readdy.ai/ai/img_res/80121dd0f57a6577df917d1042eea126.jpg',
    stats: [
      { label: 'Automatisierung', value: '95%' },
      { label: 'Zeitersparnis', value: '70%' }
    ]
  },
  {
    title: 'Amazon',
    description: 'Die vielfältigen Amazon-Programme - von CEE zu PAN-EU oder auch Global Logistics - stellen Händler vor umfangreiche rechtliche Herausforderungen, nicht zuletzt umsatzsteuerlich. Wir stellen die vollständige und korrekte Verbuchung der komplexen Amazon-Daten sicher. ',
    image: 'https://readdy.ai/api/search-image?query=amazon%20fulfillment%20center%20warehouse%20with%20organized%20inventory%20and%20logistics%20operations%2C%20professional%20e-commerce%20fulfillment%20infrastructure%2C%20modern%20distribution%20facility&width=800&height=600&seq=amazon-fba-001&orientation=landscape',
    stats: [
      { label: 'EU-Länder', value: '27' },
      { label: 'Compliance', value: '100%' }
    ]
  },
  {
    title: 'Multi-Channel Vertrieb',
    description: 'Professionelle Abbildung Ihrer Multi-Channel-Strukturen: Amazon MFN und AFN, eBay, Otto, Kaufland, Mirakl-basierte Marktplätze wie home24 oder XXXLutz und weitere Vertriebskanäle professionell aufgearbeitet und ordnungsgemäß verbucht.',
    image: 'https://readdy.ai/api/search-image?query=multiple%20e-commerce%20marketplace%20platforms%20and%20sales%20channels%20displayed%20on%20digital%20screens%2C%20integrated%20multi-channel%20retail%20technology%2C%20professional%20online%20business%20management&width=800&height=600&seq=multichannel-001&orientation=landscape',
    stats: [
      { label: 'Marktplätze', value: '25+' },
      { label: 'Integration', value: 'Nahtlos' }
    ]
  }
];

export default function EcommerceSolutions() {
  return (
    <section id="solutions" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-[#FF6B35] font-semibold text-sm uppercase tracking-wider">Spezialisierte Lösungen</span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#2F4858] mt-4 mb-6">
            E-Commerce Accounting, angepasst auf Ihr Geschäftsmodell
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Wir verstehen die spezifischen Herausforderungen Ihres Geschäftsmodells und bieten auf Ihre Situation maßgeschneiderte Lösungen - für strategisches und nachhaltiges Wachstum.
          </p>
        </div>

        <div className="space-y-16">
          {solutions.map((solution, index) => (
            <div
              key={index}
              className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-12 items-center`}
            >
              <div className="flex-1">
                <div className="relative rounded-2xl overflow-hidden shadow-2xl group">
                  <img
                    src={solution.image}
                    alt={solution.title}
                    className="w-full h-96 object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#2F4858]/60 to-transparent"></div>
                </div>
              </div>

              <div className="flex-1">
                <h3 className="text-3xl font-bold text-[#2F4858] mb-6">
                  {solution.title}
                </h3>
                <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                  {solution.description}
                </p>

                <div className="grid grid-cols-2 gap-6 mb-8">
                  {solution.stats.map((stat, idx) => (
                    <div key={idx} className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                      <div className="text-3xl font-bold text-[#FF6B35] mb-2">
                        {stat.value}
                      </div>
                      <div className="text-sm text-gray-600 font-medium">
                        {stat.label}
                      </div>
                    </div>
                  ))}
                </div>

                <a href="#contact" className="inline-flex items-center text-[#FF6B35] font-semibold hover:text-[#e55a2a] transition-colors group cursor-pointer whitespace-nowrap">
                  Mehr erfahren
                  <i className="ri-arrow-right-line ml-2 text-xl group-hover:translate-x-1 transition-transform"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}